import type { CreateOfferFormData, PaymentTypeObject } from "./types";

export const OFFER_FIELDS = {
  payment_amount: "payment_amount",
  project_duration: "project_duration",
  anticipated_weekly_hours: "anticipated_weekly_hours",
  hours_limit_type: "hours_limit_type",
  availability_details: "availability_details",
  pre_approve_extra_hours: "pre_approve_extra_hours",
  payment_type: "payment_type",
  proposed_start_date: "proposed_start_date",
  proposed_end_date: "proposed_end_date",
  note_to_talent: "note_to_talent",
  require_paperwork: "require_paperwork",
  talent_has_own_equipment: "talent_has_own_equipment",
  deposit_payment_method: "deposit_payment_method",
  additional_contract_terms: "additional_contract_terms",
  contract_terms_type: "contract_terms_type",
} as const satisfies Record<string, keyof CreateOfferFormData>;

export const JOB_PAYMENT_TYPE_LABELS: PaymentTypeObject = {
  [ENUMS.JobPaymentType.HOURLY]: "per hour",
  [ENUMS.JobPaymentType.MONTHLY]: "per month",
  [ENUMS.JobPaymentType.ANNUAL]: "per year",
  [ENUMS.JobPaymentType.FIXED_PRICE]: "fixed rate",
  [ENUMS.JobPaymentType.FIXED_PROJECT]: "fixed project",
  [ENUMS.JobPaymentType.PER_TASK]: "per task",
} as const;
